module.exports = __webpack_public_path__ + "img/loading.07b9ccff.gif";